// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface KeyIconSignature {
  Element: SVGSVGElement;
}

export const KeyIcon: TOC<KeyIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.706 8.94901L20.292 10.363L17.464 7.53601L16.05 8.95001L18.878 11.78L17.463 13.193L14.636 10.365L10.987 14.013C11.615 14.848 12 15.875 12 17C12 19.761 9.761 22 7 22C4.239 22 2 19.761 2 17C2 14.239 4.239 12 7 12C7.911 12 8.754 12.262 9.489 12.689L9.487 12.687L18.878 3.29401L20.292 4.70801L18.879 6.12101L21.706 8.94901ZM4 17C4 18.657 5.343 20 7 20C8.657 20 10 18.657 10 17C10 15.343 8.657 14 7 14C5.343 14 4 15.343 4 17Z"/>
</svg>
</template>;